<script>
  export let backend;
  let itemSubtype = null;
  let itemDescriptor = null;
  let offers = null;
  let games = [];
  let gameSelect = {
    subtypes: []
  };
  let itemTypeSelect = {
    descriptors: []
  };
  let descriptorSelect = null;

  backend.games()
    .then(g => games = g);

  function search() {
    backend.offers(gameSelect, itemTypeSelect, descriptorSelect)
     .then(o => offers = o)
  }
</script>
<main>
  <form>
    <select bind:value={gameSelect} class="form-select" aria-label="Game select">
      {#each games as game}
        <option value={game} >
          {game.name}
        </option>
      {/each}
    </select>
    {#if gameSelect != null && gameSelect.subtypes != null && gameSelect.subtypes.length > 0}
    <select bind:value={itemTypeSelect} class="form-select" aria-label="Item type select" >
      {#each gameSelect.subtypes as subtype}
        <option value={subtype}>
          {subtype.name}
        </option>
      {/each}
    </select>
    {/if}
    {#if itemTypeSelect != null && itemTypeSelect.descriptors != null && itemTypeSelect.descriptors.length > 0}
    <select class="form-select" aria-label="Descriptor select" bind:value={descriptorSelect} >
      {#each itemTypeSelect.descriptors as descriptor}
        <option value={descriptor.name}>
          {descriptor.name}
        </option>
      {/each}
    </select>
    {/if}
    {#if descriptorSelect != null}
    <button type="submit" class="btn btn-light mb-3" on:click|preventDefault ={search} >Search</button>
    {/if}
  </form>

  {#if offers != null}
  <table class="table table-sm table-dark table-striped" >
    <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Id</th>
      <th scope="col">User</th>
      <th scope="col">User rating</th>
      <th scope="col">User completion rate</th>
      <th scope="col">Provider</th>
      <th scope="col">Quantity</th>
      <th scope="col">Price</th>
      <th scope="col">Price Rub</th>
    </tr>
    </thead>

    <tbody>
    {#each offers as offer, index}
    <tr>
      <th scope="row">{index}</th>
      <td><a class="link-light" href={offer.url}>{offer.id}</a></td>
      <td><a class="link-light" href={offer.userUrl}>{offer.userName}</a></td>
      {#if offer.sellerData != null && offer.sellerData.rating != null}
        <td>{Math.round((offer.sellerData.rating + Number.EPSILON) * 100 * 100) / 100}%</td>
      {/if}
      {#if offer.sellerData == null || offer.sellerData.rating == null}
        <td>?</td>
      {/if}
      {#if offer.sellerData != null && offer.sellerData.completionRate != null}
        <td>{Math.round((offer.sellerData.completionRate + Number.EPSILON) * 100 * 100) / 100}%</td>
      {/if}
      {#if offer.sellerData == null || offer.sellerData.completionRate == null}
        <td>?</td>
      {/if}
      <td>{offer.provider}</td>
      <td>{offer.quantity}</td>
      <td>{offer.price}</td>
      <td>{offer.priceRub}</td>
    </tr>
    {/each}
    </tbody>
  </table>
  {/if}
</main>

